@if (data?.selectedTicket) {
    <mat-card appearance="outlined">
        <mat-card-content>
            <div class="tw-flex tw-flex-col">
                <div class="tw-flex tw-justify-between tw-items-center">
                    <div
                        class="tw-justify-between tw-text-xl tw-flex-col tw-flex tw-w-3/4 tw-mr-2"
                    >
                        <mat-label>
                            {{
                                data?.selectedTicket?.ticketNum
                                    ? "#" + data?.selectedTicket.ticketNum
                                    : "Ticket Number Missing"
                            }}
                        </mat-label>
                    </div>

                    <mat-chip
                        [ngClass]="{
                            'm3-success':
                                data?.selectedTicket.status ===
                                Status.Processed,
                            'm3-caution':
                                data?.selectedTicket.status === Status.Updated,
                            'm3-primary':
                                data?.selectedTicket.status === Status.New
                        }"
                        highlighted
                        class="tw-ml-auto"
                    >
                        <div class="tw-min-w-20 tw-text-center">
                            {{ data?.selectedTicket.status ?? "Unknown" }}
                        </div>
                    </mat-chip>
                </div>

                <div class="tw-flex">
                    <div>
                        -
                        {{
                            data?.selectedTicket.submittedByName ??
                                "Unknown User"
                        }}
                    </div>
                </div>

                <div class="tw-flex tw-flex-col tw-gap-1">
                    <div class="tw-m-3 tw-text-base tw-flex tw-flex-col">
                        <div
                            class="tw-font-medium"
                            [innerHTML]="
                                data?.selectedTicket.description ??
                                'No Ticket Description Provided'
                            "
                        ></div>
                        <div
                            class="tw-m-3 tw-mb-0 tw-text-base tw-overflow-y-auto tw-max-h-[175px]"
                            [innerHTML]="
                                data?.selectedTicket.details ??
                                'No Ticket Body Provided'
                            "
                        ></div>
                    </div>
                    <div
                        class="tw-gap-2 tw-flex tw-flex-col tw-m-3 tw-overflow-y-auto tw-h-[250px]"
                    >
                        @for (comment of comments.items; track comment) {
                            <div
                                class="tw-border-solid tw-rounded-lg tw-border-2 tw-border-customborder tw-break-all"
                            >
                                <div class="tw-m-2">
                                    {{
                                        comment.text ??
                                            "Comment Could Not Be Found"
                                    }}
                                </div>

                                <div class="tw-m-2 tw-flex tw-justify-end">
                                    -
                                    {{
                                        comment.submittedByName ??
                                            "Unknown User"
                                    }}
                                </div>
                            </div>
                        }
                    </div>

                    <div class="tw-mt-auto tw-m-3">
                        <button
                            mat-raised-button
                            class="tw-text-l"
                            (click)="addComment()"
                            [disabled]="
                                statusForm.controls.processed.value ||
                                statusForm.controls.duplicate.value
                            "
                        >
                            <mat-icon>add</mat-icon>
                            Comment
                        </button>
                    </div>

                    @if (!data?.userView) {
                        <form
                            [formGroup]="statusForm"
                            class="tw-flex tw-flex-row tw-ml-auto tw-m-3 tw-gap-3"
                        >
                            <label>
                                <input
                                    type="checkbox"
                                    formControlName="processed"
                                    (change)="
                                        onCheckboxChange(Status.Processed)
                                    "
                                />
                                Mark as Processed
                            </label>
                            <label>
                                <input
                                    type="checkbox"
                                    formControlName="duplicate"
                                    (change)="
                                        onCheckboxChange(Status.Duplicate)
                                    "
                                />
                                Mark as Duplicate
                            </label>
                        </form>
                    }
                </div>
            </div>
        </mat-card-content>
    </mat-card>
}
